'use client';

import React, { useState, useEffect } from 'react';
import Image from 'next/image';
import {
  Header,
  ReversibleComponent,
  ReverseText,
  ReverseImage,
  ReverseImageTwo,
  ReverseImageThree,
  WhyCirclePlug,
  FAQ,
  Footer,
} from '../..';
import {
  appstorebtn,
  googleplaybtn,
  headerImage,
  membership,
  events,
  discussion,
  payment,
  courses,
  brandlogo,
} from '../../../assets';
import styles from './page.module.css';
import Link from 'next/link';
import { Helmet } from 'react-helmet';

const reasonsForCirclePlug = [
  {
    name: 'Private messaging',
    value: 'Private messaging',
  },
  {
    name: 'Messaging channels',
    value: 'Messaging channels',
  },
  {
    name: 'Member directory',
    value: 'Member directory',
  },
  {
    name: 'Manage events',
    value: 'Manage events',
  },
  {
    name: 'Gate Pass Access',
    value: 'Gate Pass Access',
  },
  {
    name: 'Paid membership',
    value: 'Paid membership',
  },
  {
    name: 'Event tickets management',
    value: 'Event tickets management',
  },
  {
    name: 'One-time membership',
    value: 'One-time membership',
  },
  {
    name: 'Recurring subscription',
    value: 'Recurring subscription',
  },
  {
    name: 'Roles & permission',
    value: 'Roles & permission',
  },
  {
    name: 'Payment processing',
    value: 'Payment processing',
  },
  {
    name: 'Host courses',
    value: 'Host courses',
  },
  {
    name: 'Community identity',
    value: 'Community identity',
  },
  {
    name: 'Gift cash',
    value: 'Gift cash',
  },
  {
    name: 'Personalised wallet',
    value: 'Personalised wallet',
  },
  {
    name: 'Access control',
    value: 'Access control',
  },
  {
    name: 'Access logs',
    value: 'Access logs',
  },
];

const midpoint = Math.ceil(reasonsForCirclePlug.length / 2);

const firstColumn = reasonsForCirclePlug.slice(0, midpoint);
const secondColumn = reasonsForCirclePlug.slice(midpoint);

const carouselItems = [
  {
    id: 1,
    title: 'Membership',
    image: membership,
    descriptionTitle: 'Monetize your way!',
    description: `
      CirclePlug empowers you to offer memberships, one-time access, free trials, or recurring subscriptions – the choice is yours.
    `,
  },
  {
    id: 2,
    title: 'Events',
    image: events,
    descriptionTitle: 'Experience Moments!',
    description: `
      Be part of it all, from workshops and seminars to networking sessions, there's something for everyone.
    `,
  },
  {
    id: 3,
    title: 'Discussion',
    image: discussion,
    descriptionTitle: 'Spark Conversations!',
    description: `
      Join discussions with experts, share insights, and collaborate on ideas to take your business forward.
    `,
  },
  {
    id: 4,
    title: 'Payment',
    image: payment,
    descriptionTitle: 'Happy Customers!',
    description: `
     Say hello to simple transactions that keep your customers coming back for more.
    `,
  },
  {
    id: 5,
    title: 'Products',
    image: courses,
    descriptionTitle: 'Power your business!',
    description: `
     Take control of your business with our all-in-one solution for inventory, payments, orders, and beyond.
    `,
  },
];

const circlePlugCommunity = [
  {
    id: 1,
    name: 'gaming community',
    textColor: 'orange',
  },
  {
    id: 2,
    name: 'wellness community',
    textColor: 'brown',
  },
  {
    id: 3,
    name: 'parenting community',
    textColor: 'green',
  },
  {
    id: 4,
    name: 'fitness community',
    textColor: 'purple',
  },
  {
    id: 5,
    name: 'estate management',
    textColor: 'magenta',
  },
  {
    id: 6,
    name: 'education community',
    textColor: 'green',
  },
  {
    id: 7,
    name: 'wellness community',
    textColor: 'purple',
  },
  {
    id: 8,
    name: 'pet owners community',
    textColor: 'blue',
  },
];

export default function Home() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentPlug, setCurrentPlug] = useState(0);

  const intervalTime = 5000;

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % carouselItems.length);
    }, intervalTime);

    return () => clearInterval(interval);
  }, [intervalTime]);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentPlug((prevIndex) => (prevIndex + 1) % circlePlugCommunity.length);
    }, 3000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  const handleCarouselClick = (index) => {
    setCurrentIndex(index);
  };

  const currentItem = carouselItems[currentIndex];
  const currentCommunity = circlePlugCommunity[currentPlug];

  return (
    <main className={styles.main}>
      <Helmet>
        <title>CirclePlug | Everything your community needs, all in one place</title>
        <meta
          name="description"
          content="Forget juggling multiple platforms! Build, engage, and monetize your thriving community – all within one seamless platform."
        />
      </Helmet>
      <div className={styles.firstFrame}>
        <Header
          brand={brandlogo}
          backgroundColor={styles.backColor}
          mobileBrand={brandlogo}
          brandToggle={brandlogo}
        />
        <div className={styles.firstFramewrapper}>
          <div className={styles.headerBody}>
            <div className={styles.headerBodyleftmain}>
              <div className={styles.headerBodylefttextsbuttons}>
                <div className={styles.headerBodylefttexts}>
                  <p className={styles.toplefttext}>Everything your community needs, all in one place.</p>
                  <p className={styles.bottomlefttext}>
                    Forget juggling multiple platforms! Build, engage, and monetize your thriving community –
                    all within one seamless platform.
                  </p>
                </div>
                <div className={styles.platformbuttons}>
                  <Link
                    target={'_blank'}
                    className={styles.platformbutton}
                    href={`https://apps.apple.com/ng/app/circleplug/id6462672418`}
                  >
                    <Image src={appstorebtn} alt="app store button" />
                  </Link>

                  <Link
                    target={'_blank'}
                    className={styles.platformbutton}
                    href={`https://play.google.com/store/apps/details?id=com.shypes.circlePlug`}
                  >
                    <Image src={googleplaybtn} alt="google play button" />
                  </Link>
                </div>
              </div>
            </div>
            <div className={styles.headerBodyright}>
              <span className={styles.headerimage}>
                <Image src={headerImage} alt="header image" width={628} height={514.96} />
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.secondFrame}>
        <div className={styles.secondFramewrapper}>
          <div className={styles.estatereverse}>
            <ReversibleComponent
              leftElement={
                <ReverseText
                  badge="start"
                  heading="Launch Your Circle: Create, Discover, Belong"
                  description={`Forget juggling multiple platforms! CirclePlug streamlines your community experience. Create your dream community, discover exciting groups to join, and connect with like-minded individuals through our member directory. `}
                />
              }
              rightElement={<ReverseImage />}
              isReversed={false}
            />
          </div>
          <div className={styles.estatereverse}>
            <ReversibleComponent
              leftElement={
                <ReverseText
                  badge="engage"
                  heading="Connect, Collaborate, and Create"
                  description={`Bring your community to life with our vibrant personal messaging, channel communication, and engagement features. Seamlessly host and manage your events while staying updated on all the communications and activities within your community.`}
                />
              }
              rightElement={<ReverseImageTwo />}
              isReversed={true}
            />
          </div>
          <div className={styles.reverse}>
            <ReversibleComponent
              leftElement={
                <ReverseText
                  badge="monetise"
                  heading="Monetise, Earn & Grow with Your Community"
                  description={`Offer exclusive content, tiered memberships, paid events, and more. We provide the tools you need to thrive, from free trials and recurring subscriptions to seamless payment processing. Let's build a community that benefits everyone.`}
                />
              }
              rightElement={<ReverseImageThree />}
              isReversed={false}
            />
          </div>

          <div className={styles.whyCirclePlug}>
            <div className={styles.whyCirclePlugbadge}>
              <span className={styles.whyCirclePlugbadge}>
                <p className={styles.whyCirclePlugbadgetext}>WHY CIRCLEPLUG</p>
              </span>
            </div>
            <div className={styles.whyCirclePlugdescriptions}>
              <p className={styles.whyCirclePlugdescriptionbold}>
                Everything you need to manage and grow your <br />
                <span className={styles.dynamicphrase} style={{ color: currentCommunity.textColor }}>
                  {currentCommunity.name}
                </span>{' '}
                <br />
                in one place
              </p>
              <p className={styles.whyCirclePlugdescriptionthin}>
                Imagine a world where your community thrives, discussions spark, knowledge flows freely, and
                earning opportunities flourish – all within a single, intuitive platform
              </p>
            </div>
            <div className={styles.reasonsForCirclePlug}>
              <div className={styles.columnOne}>
                {firstColumn.map(({ name, value }) => (
                  <WhyCirclePlug key={name} reason={value} />
                ))}
              </div>
              <div className={styles.columnTwo}>
                {secondColumn.map(({ name, value }) => (
                  <WhyCirclePlug key={name} reason={value} />
                ))}
              </div>
            </div>
          </div>

          <div className={styles.whycircleplugImagewrapper}>
            <div className={styles.carouselwithindicator}>
              <div className={styles.carouseltop}>
                <div className={styles.carouseltopleft}>
                  <ul className={styles.carouseltextList}>
                    {carouselItems.map((item, index) => (
                      <li
                        key={item.id}
                        className={`${styles.carouseltextItem} ${
                          index === currentIndex ? styles.acarouselctiveText : ''
                        }`}
                        onClick={() => handleCarouselClick(index)}
                      >
                        {item.title}
                      </li>
                    ))}
                  </ul>
                </div>
                <div className={styles.carouseltopright}>
                  <div className={styles.carouseltopright_image}>
                    <Image src={currentItem.image} alt={currentItem.title} width={526} height={447} />
                  </div>

                  <div className={styles.carouseltopright_desc}>
                    <span className={styles.descriptionTitle}>{currentItem.descriptionTitle}</span>
                    {currentItem.description}
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.carouselbottom}>
              {carouselItems.map((item, index) => (
                <span
                  key={item.id}
                  className={`${styles.indicator} ${index === currentIndex ? styles.activeIndicator : ''}`}
                ></span>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className={styles.homethirdFrame}>
        <div className={styles.thirdFramewrapper}>
          <div className={styles.thirdFrametop}>
            <div className={styles.thirdFramebadge_title}>
              <span className={styles.thirdFramebadge}>get started</span>
              <p className={styles.thirdFrame_title}>Download our App</p>
            </div>
            <p className={styles.thirdFrame_description}>
              Start your journey to empowering your community with our one stop app for building, engaging,
              and empowering your community
            </p>
          </div>
          <div className={styles.thirdFramebottom}>
            <div className={styles.platformbuttons}>
              <Link
                target={'_blank'}
                className={styles.platformbutton}
                href={`https://apps.apple.com/ng/app/circleplug/id6462672418`}
              >
                <Image src={appstorebtn} alt="app store button" />
              </Link>
              <Link
                target={'_blank'}
                className={styles.platformbutton}
                href={`https://play.google.com/store/apps/details?id=com.shypes.circlePlug`}
              >
                <Image src={googleplaybtn} alt="google play button" />
              </Link>
            </div>
          </div>
        </div>
        <div className={styles.faqFramewrapper}>
          <FAQ />
        </div>
        <div className={styles.homefifthFrame}>
          <Footer />
        </div>
      </div>
    </main>
  );
}
